import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/8kov4JtzGEoAv2qu39gv/locations/3icOids2jYKlO7M9weba`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="50%"
                  minWidth="280px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/8kov4JtzGEoAv2qu39gv/locations/3icOids2jYKlO7M9weba`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="325px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
